export default __webpack_public_path__ + "static/media/Capture-removebg-preview.6bc8ceac.png";